<app-showcase></app-showcase>
<app-bulletin></app-bulletin>
<!-- <app-vision-mission></app-vision-mission> -->
<app-messages></app-messages>
<app-counter></app-counter>
<app-notice-circular></app-notice-circular>
<app-certificate-cta></app-certificate-cta>
<app-courses></app-courses>
<!-- <app-events></app-events> -->
<app-why></app-why>
<app-quick-links></app-quick-links>
<app-student-parent-hub></app-student-parent-hub>
<!-- <app-campus-life></app-campus-life> -->
<!-- <app-alumni></app-alumni> -->